import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { downloadDocument } from '@/features/documents/api/download-documents';
import { toast } from '@/shared/hooks/use-toast';

export const useDownloadDocument = () => {
  const { t } = useTranslation('document');
  return useMutation({
    mutationFn: downloadDocument,
    onError: (error) => {
      toast({
        title: t('Errors.download_error'),
        description: error.message,
      });
    },
  });
};
